"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9251],{

/***/ 57241:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

function useClickOutside(ref, callback) {
    // useEffect(() => {
    //   function handleClick(event: any) {
    //     if (ref.current && !ref.current.contains(event.target)) {
    //       callback();
    //     }
    //   }
    //   document.addEventListener('click', handleClick);
    //   return () => {
    //     document.removeEventListener('click', handleClick);
    //   };
    // }, [ref, callback]);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var handleClick = function(event) {
            if (!ref.current || ref.current.contains(event.target)) {
                return;
            }
            callback(event);
        };
        document.addEventListener("mousedown", handleClick);
        document.addEventListener("touchstart", handleClick);
        return function() {
            document.removeEventListener("mousedown", handleClick);
            document.removeEventListener("touchstart", handleClick);
        };
    }, [
        ref,
        callback
    ]);
}
/* harmony default export */ __webpack_exports__["Z"] = (useClickOutside);


/***/ }),

/***/ 93567:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

var BiVideoPlayIcon = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        stroke: "currentColor",
        fill: "currentColor",
        strokeWidth: "0",
        viewBox: "0 0 24 24",
        height: "1em",
        width: "1em",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M7 6v12l10-6z"
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (BiVideoPlayIcon);


/***/ }),

/***/ 56100:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

var BsThreeDotsIcon = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        stroke: "currentColor",
        fill: "currentColor",
        strokeWidth: "0",
        viewBox: "0 0 16 16",
        height: "1em",
        width: "1em",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M3 9.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z"
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (BsThreeDotsIcon);


/***/ }),

/***/ 14572:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ VideoCloseButton_VideoCloseButton; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs + 1 modules
var _object_spread = __webpack_require__(41799);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/views/Home/WhoWeAreSection/VideoCloseButton/VideoCloseButton.tsx






function VideoCloseButton(_param) {
    var isVideoModalClose = _param.isVideoModalClose, props = (0,_object_without_properties/* default */.Z)(_param, [
        "isVideoModalClose"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        "aria-label": "close btn",
        className: classnames_default()("group relative z-[999] overflow-hidden cursor-pointer bg-primary duration-150 h-[70px] w-[70px] aspect-square flex items-center justify-center"),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "relative w-5 h-3.5 translate-x-1.5",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: classnames_default()("absolute top-1/2 left-0 h-0.5 w-full inline-block bg-white -translate-x-1 -translate-y-1/2 rotate-45", !isVideoModalClose && "-left-[calc(100%+25px)] -top-[calc(100%+25px)] opacity-60 duration-150")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: classnames_default()("absolute top-1/2 left-0 h-0.5 w-full inline-block bg-white -translate-x-1 -translate-y-1/2 rotate-45", !isVideoModalClose && "top-[calc(100%+25px)] left-[calc(100%+25px)] opacity-60 duration-150")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: classnames_default()("absolute top-1/2 left-0 h-0.5 w-full inline-block bg-white -translate-x-1 -translate-y-1/2 -rotate-45", !isVideoModalClose && "-top-[calc(100%+37px)] left-[calc(100%+24px)] opacity-60 duration-150")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: classnames_default()("absolute top-1/2 left-0 h-0.5 w-full inline-block bg-white -translate-x-1 -translate-y-1/2 -rotate-45", !isVideoModalClose && "top-[calc(100%+37px)] -left-[calc(100%+24px)] opacity-60 duration-150")
                })
            ]
        })
    }));
}
/* harmony default export */ var VideoCloseButton_VideoCloseButton = (VideoCloseButton);

;// CONCATENATED MODULE: ./src/views/Home/WhoWeAreSection/VideoCloseButton/index.ts




/***/ }),

/***/ 89845:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _hooks_useClickOutside__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(57241);
/* harmony import */ var _views_Home_WhoWeAreSection_VideoCloseButton__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14572);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var gsap__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(10990);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(67294);
/* harmony import */ var react_player__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(22004);
/* harmony import */ var src_icons_BiVideoPlayIcon__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(93567);
/* harmony import */ var src_icons_BsThreeDotsIcon__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(56100);










var VideoContainer = function(param) {
    var data = param.data, isVimeoSrc = param.isVimeoSrc;
    // States
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)(false), isVideoModalOpen = ref[0], setIsVideoModalOpen = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)(false), isVideoMuted = ref1[0], setIsVideoMuted = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)(false), isPlay = ref2[0], setIsPlay = ref2[1];
    // Refs
    var videoModal = (0,react__WEBPACK_IMPORTED_MODULE_5__.useRef)(null);
    var ditectOutside = (0,react__WEBPACK_IMPORTED_MODULE_5__.useRef)(null);
    // Use Effects
    (0,react__WEBPACK_IMPORTED_MODULE_5__.useEffect)(function() {
        var ref, ref1;
        isVideoModalOpen ? (ref = document.querySelector("body")) === null || ref === void 0 ? void 0 : ref.classList.add("overflow-hidden") : (ref1 = document.querySelector("body")) === null || ref1 === void 0 ? void 0 : ref1.classList.remove("overflow-hidden");
    }, [
        isVideoModalOpen
    ]);
    // Normal Functions
    var handleOpenVideo = function() {
        setIsVideoModalOpen(true);
        if (isVimeoSrc) {
            setIsPlay(true);
        } else {
            videoModal.current.play();
        }
    };
    var handleCloseVideo = function() {
        setIsVideoModalOpen(false);
        if (isVimeoSrc) {
            setIsPlay(false);
        } else {
            videoModal.current.pause();
        }
    };
    var handleVideoMuteUnMute = function() {
        setIsVideoMuted(function(prev) {
            return !prev;
        });
        if (!isVimeoSrc) {
            videoModal.current.muted ? videoModal.current.muted = false : videoModal.current.muted = true;
        }
    };
    //Hooks
    (0,_hooks_useClickOutside__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(ditectOutside, function() {
        handleCloseVideo();
    });
    (0,react__WEBPACK_IMPORTED_MODULE_5__.useEffect)(function() {
        window.requestAnimationFrame(function() {
            var ProjectVideoTl = gsap__WEBPACK_IMPORTED_MODULE_9__/* ["default"].timeline */ .ZP.timeline({
                scrollTrigger: {
                    trigger: "._projectVideoTrigger",
                    start: "`top 100%",
                    scrub: 0.9
                }
            });
            ProjectVideoTl.to("._projectVideo", {
                y: -150,
                duration: 0.8,
                ease: "none"
            }, "start");
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "bg-[#F5F5F5] lg:p-[5rem_7rem] _projectVideoTrigger",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "overflow-hidden hidden lg:block rounded-[0.35714rem] !relative top-32 mt-5 h-full _projectVideo shadow-[0_0_26px_0_rgb(0_0_0_/_20%)] w-[50vw] mx-auto",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "__imageRedBorder h-[2.5rem] text-white bg-primary rounded-tl-[0.35714rem] rounded-tr-[0.35714rem]",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: "absolute left-[1rem] text-[35px]",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_icons_BsThreeDotsIcon__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {})
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "relative",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                        src: data === null || data === void 0 ? void 0 : data.videoThumbnail,
                                        alt: "image background",
                                        width: "100%",
                                        height: "100%"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        onClick: handleOpenVideo,
                                        className: "absolute top-0 left-0 flex items-center justify-center w-full h-full bg-black/50 cursor-pointer",
                                        ref: ditectOutside,
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "p-2 text-6xl text-white border border-white cursor-pointer",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_icons_BiVideoPlayIcon__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {})
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "overflow-hidden h-full lg:hidden block shadow-[0_0_26px_0_rgb(0_0_0_/_20%)]",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "hidden w-full h-[35px] pl-3 text-3xl text-white bg-primary lg:block",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_icons_BsThreeDotsIcon__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {})
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "relative",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                        src: data === null || data === void 0 ? void 0 : data.videoThumbnail,
                                        alt: "image background",
                                        width: "100%",
                                        height: "100%"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        onClick: handleOpenVideo,
                                        className: "absolute top-0 left-0 flex items-center justify-center w-full h-full bg-black/50 cursor-pointer",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "p-2 text-6xl text-white border border-white cursor-pointer",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_icons_BiVideoPlayIcon__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {})
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: classnames__WEBPACK_IMPORTED_MODULE_3___default()("fixed h-full w-full top-0 left-0 bg-white/30 backdrop-blur-lg  z-[999]", !isVideoModalOpen && "pointer-events-none duration-150 delay-150 opacity-0"),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "absolute top-0 left-0 right-0 w-full flex justify-between",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "h-[70px] relative z-[999] aspect-square flex items-center justify-center",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                        src: "/imgs/logos/new/logo-red-dot.svg",
                                        alt: "logo svg image",
                                        width: 32,
                                        height: 32,
                                        className: "relative z-[999] w-[32px] md:w-[2.3rem]"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "absolute inset-0 bg-redblack w-full h-full __logoBg"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_views_Home_WhoWeAreSection_VideoCloseButton__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                onClick: handleCloseVideo,
                                isVideoModalClose: isVideoModalOpen,
                                ref: ditectOutside
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        ref: ditectOutside,
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                children: isVimeoSrc ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "h-full lg:w-[70%] w-[90%] absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_player__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                        className: "h-full lg:w-[70%] w-[90%] absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2",
                                        url: data === null || data === void 0 ? void 0 : data.videoSrc,
                                        controls: false,
                                        // config={{ vimeo: { playerOptions: { background: true } } }}
                                        width: "100%",
                                        height: "90%",
                                        volume: isVideoMuted ? 0 : 1,
                                        playing: isPlay,
                                        loop: true
                                    })
                                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("video", {
                                    ref: videoModal,
                                    className: classnames__WEBPACK_IMPORTED_MODULE_3___default()("h-[90%] lg:w-[70%] w-[90%] absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2"),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("source", {
                                        src: data === null || data === void 0 ? void 0 : data.videoSrc
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                onClick: handleVideoMuteUnMute,
                                className: "absolute lg:top-1/2 lg:-translate-y-1/2 right-0 bottom-0 videoMuteUnmute cursor-pointer w-[70px] h-[70px]",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_4___default()), {
                                        src: "/imgs/video_mute.gif",
                                        layout: "fill",
                                        priority: true,
                                        draggable: false,
                                        alt: "video mute",
                                        className: classnames__WEBPACK_IMPORTED_MODULE_3___default()(isVideoMuted ? "opacity-100" : "opacity-0")
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_4___default()), {
                                        src: "/imgs/video_unmute.gif",
                                        layout: "fill",
                                        priority: true,
                                        draggable: false,
                                        alt: "video unmute",
                                        className: classnames__WEBPACK_IMPORTED_MODULE_3___default()(isVideoMuted ? "opacity-0" : "opacity-100")
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (VideoContainer);


/***/ })

}]);